import { render, staticRenderFns } from "./AppointmentModal.vue?vue&type=template&id=4618727f&"
import script from "./AppointmentModal.vue?vue&type=script&lang=js&"
export * from "./AppointmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports